/* eslint-disable */

window.googletag = window.googletag || {cmd: []};

function setTags() {
	var tags = [];
	if (typeof tp !== "undefined" && Array.isArray(tp)) {
		tp.forEach(function(entry) {
			if (entry[0] === "setTags") {
				tags = entry[1];
			}
		});
	}
	if (tags.length > 0) {
		googletag.pubads().setTargeting('tags', tags);
	}
}

googletag.cmd.push(function() {

	setTags();

	const domain = window.location.origin;
	const pagePath = ((window.location.pathname || "") + (window.location.search || "") + (window.location.hash || "")).substring(0, 40);
	const pageUrl = (window.location.href || "").substring(0, 40);

	googletag.pubads().setTargeting("domain", domain);
	googletag.pubads().setTargeting("pagePath", pagePath);
	googletag.pubads().setTargeting("page", [pageUrl]);

	// Check if article or newsletter type.
	const isArticle = document.querySelector('.advert-gpt--type-article');
	const isNewsletter = document.querySelector('.advert-gpt--type-newsletter');

	if (isArticle) {
		// Define slot for article type.
		googletag.defineSlot('/23275091852/poland_unpacked/poland_unpacked_article_page', [[300, 250], [300, 600]], 'div-gpt-ad-1774350517522-0')
			.addService(googletag.pubads());
	} else if (isNewsletter) {
		// Define slot for newsletter type.
		googletag.defineSlot('/23275091852/poland_unpacked/poland_unpacked_newsletter_page', [[300, 600], [300, 250]], 'div-gpt-ad-1763037525175-0')
			.addService(googletag.pubads());
	}

	googletag.pubads().enableSingleRequest();
	googletag.enableServices();
});
